import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
    wrapper: {
        height: "calc(100% - 6px)",
        width: "100%",
        display: "flex",
        gap: theme.spacing(3),
    },
    side: {
        height: "100%",
        width: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    tableContainer: {
        maxWidth: "135px !important",
    },
    tableRow: {
        "&:last-child td, &:last-child th": { border: 0 },
    },
    tableRowHover: {
        "&:hover": {
            backgroundColor: theme.palette.primary.light,
            cursor: "pointer",
        },
    },
    tableRowSelected: {
        backgroundColor: theme.palette.primary.light,
    },
    tableCell: {
        padding: `${theme.spacing(0.5)} !important`,
        gap: theme.spacing(3),
    },
    tableCellPadding: {
        padding: `${theme.spacing(0.5)} !important`,
    },
    title: {
        fontSize: "10px !important",
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
    },
    total: {
        fontWeight: "800 !important",
    },
    labelWrapper: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(3),
        width: "100%",
    },
    dot: {
        height: theme.spacing(1.25),
        width: theme.spacing(1.25),
        borderRadius: "50%",
    },
    noData: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
    },
}));

export const theme = {
    tooltip: {
        container: {
            display: "none",
        },
    },
    labels: {
        text: {
            fontSize: 12,
            fontFamily: "Source Sans 3",
            fontWeight: 400,
        },
    },
};
